import axios, { retryOnErrors, throttleRequests } from '@fs/zion-axios'
import zionDebug from '@fs/zion-debug'
import { makeUseAxios } from 'axios-hooks'

const debug = zionDebug('temple:axios')

const MIN_THROTTLING_SECS = 50

/** An axios instance that retries on 429 (and several other) errors. */
export const axiosRetry = (() => {
  const axiosInstance = axios.create({ useNewInterceptors: true })
  retryOnErrors(axiosInstance)
  return axiosInstance
})()

export default axiosRetry

export const useZionAxiosRetry = makeUseAxios({
  axios: axiosRetry,
})

/**
 * Calls axios.get() on an array of URLs, throttling to issue no more than `callsPerSec`
 * requests per second.
 * @param {string[]} urls - The URLs to call.
 * @param {number} callsPerSec - The number of calls per second to throttle to. 0 for no throttling.
 * @returns  {Promise<string>} - Promise of all url requests
 */
export async function axiosThrottled(urls, callsPerSec = 0) {
  let axiosInstance = axiosRetry
  if (callsPerSec && callsPerSec * MIN_THROTTLING_SECS <= urls.length) {
    axiosInstance = axios.create({ useNewInterceptors: true })
    retryOnErrors(axiosInstance)
    throttleRequests(axiosInstance, 1000 / callsPerSec)
    debug(`Throttling requests at ${callsPerSec} calls per second`)
  }

  const urlRequests = urls.map((url) => axiosInstance.get(url))
  // TODO: What is the proper error handling here?
  return Promise.all(urlRequests)
}
